export const TOKEN_NAME = process.env.REACT_APP_TOKEN_NAME;
export const RIDGE_API = process.env.REACT_APP_RIDGE_API;
export const SARBJIT_API = process.env.REACT_APP_SARBJIT_API;
export const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;